import {
  preApprovalCategory,
  preApprovalCategoryPercentage,
} from 'ppbl/utils/constants'
import { getLocalizedText } from 'ppbl/utils/locale-helper'
import { interpolate } from 'ppbl/utils/string-helper'

const disclaimerContentMap: Record<preApprovalCategory, string> = {
  [preApprovalCategory.PREAPPROVED]: interpolate(
    getLocalizedText('components.disclaimer.preApprovedText'),
    {
      percentage: preApprovalCategoryPercentage.PREAPPROVED,
    },
  ),
  [preApprovalCategory.VERY_HIGH]: interpolate(
    getLocalizedText('components.disclaimer.veryHighText'),
    {
      percentage: preApprovalCategoryPercentage.VERY_HIGH,
    },
  ),
  [preApprovalCategory.HIGH]: interpolate(
    getLocalizedText('components.disclaimer.highText'),
    {
      percentage: preApprovalCategoryPercentage.HIGH,
    },
  ),
  [preApprovalCategory.LOW]: interpolate(
    getLocalizedText('components.disclaimer.lowText'),
    {
      percentage: preApprovalCategoryPercentage.LOW,
    },
  ),
  [preApprovalCategory.VERY_LOW]: '', // not applicable as disclaimer is not shown for this category as of now, subject to change based on business requirements
  [preApprovalCategory.INELIGIBLE]: '', // not applicable as disclaimer is not shown for this category as of now, subject to change based on business requirements
}

const getDisclaimerContent = (
  approvalCategory: preApprovalCategory,
): string => {
  return disclaimerContentMap[approvalCategory] ?? ''
}

export default getDisclaimerContent
